import React, { useEffect } from "react";
import { matchRoutes, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// eslint-disable-next-line import/no-unresolved
import buildConfig from "@regional/config/build.config.json";

import Paper from "@mui/material/Paper";
import classes from "./App.module.css";
import Layout from "./features/auth/components/Layout";
import routes from "./routes-config";

function RoutesWrapper({ user }) {
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    const matchedRoutes = matchRoutes(routes, location);
    let title = "";
    if (matchedRoutes?.length) {
      const matchedRoute = matchedRoutes[matchedRoutes.length - 1];
      if (matchedRoute.route?.documentTitle)
        title = `${matchedRoute.route.documentTitle} | `;
    }
    title += buildConfig.title;
    document.title = title;
  }, [pathname, location]);

  return (
    <Paper
      sx={(theme) => ({
        borderRadius: 0,
        backgroundColor: theme.palette.mode === "light" ? "#f3f2f2" : undefined,
      })}
      className={`${classes.wrapper} ${
        user && !user.addNewUser && !pathname.includes("browser-support")
          ? classes.stateful
          : classes.stateless
      }`}
    >
      {/* render a router for the protected pages if there is a logged in user
            or the public pages if there is no logged in user
            protected pages should never be rendered in any way if there is no logged in user */}
      <Layout />
    </Paper>
  );
}
RoutesWrapper.propTypes = {
  user: PropTypes.shape({}),
};
RoutesWrapper.defaultProps = {
  user: null,
};
export default RoutesWrapper;
